// extracted by mini-css-extract-plugin
export default {"recos":"c5-z","productCardOverride":"d5-z","rowHasBadge":"e5-z"};